import { formatMoney, GRINDS, labelOf, WEIGHTS } from '@c214/shared';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../providers';
import { PackArt } from '../product/PackArt';
import { Button } from '../ui/button';
import { FreeShippingBar } from '../ui/free-shipping-bar';
import { QuantityStepper } from '../ui/quantity-stepper';

export function CartDrawer() {
  const cart = useCart();
  const navigate = useNavigate();
  if (!cart.isOpen) return null;

  return (
    <div className="fixed inset-0 z-30">
      <button
        type="button"
        aria-label="Закрити кошик"
        onClick={cart.close}
        className="absolute inset-0 animate-veil border-none bg-black/60 p-0"
      />
      <aside className="absolute right-0 top-0 flex h-full w-[min(420px,100%)] animate-slideIn flex-col border-l border-line bg-surface">
        <div className="flex items-center justify-between border-b border-line px-6 py-5">
          <span className="mono-label text-ink">КОШИК</span>
          <button
            type="button"
            onClick={cart.close}
            className="border-none bg-transparent text-[20px] text-muted cursor-pointer"
          >
            ✕
          </button>
        </div>

        {cart.items.length === 0 ? (
          <p className="px-6 py-8 text-[15px] text-muted">
            Поки порожньо. Оберіть сорт у каталозі.
          </p>
        ) : (
          <div className="flex-1 overflow-y-auto">
            {cart.items.map((line) => (
              <div key={line.key} className="flex gap-4 border-b border-line-soft px-6 py-4">
                <PackArt variant="mini" name={line.name} className="h-[70px] w-14 shrink-0" />
                <div className="flex-1">
                  <p className="text-[15px] font-bold text-ink">{line.name}</p>
                  <p className="mono-label mt-1">
                    {labelOf(WEIGHTS, line.weight)} · {labelOf(GRINDS, line.grind)}
                  </p>
                  <div className="mt-3 flex items-center justify-between">
                    <QuantityStepper
                      value={line.qty}
                      onChange={(qty) => cart.setQty(line.key, qty)}
                    />
                    <span className="text-[15px] font-bold text-ink">
                      {formatMoney(line.unitPrice * line.qty)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="border-t border-line px-6 py-5">
          {cart.items.length > 0 && <FreeShippingBar itemsTotal={cart.total} />}
          <div className="mb-4 flex items-center justify-between">
            <span className="mono-label">РАЗОМ</span>
            <span className="text-[24px] font-extrabold text-ink">{formatMoney(cart.total)}</span>
          </div>
          <Button
            variant="accent"
            size="lg"
            className="w-full"
            disabled={cart.items.length === 0}
            onClick={() => {
              cart.close();
              navigate('/checkout');
            }}
          >
            ОФОРМИТИ ЗАМОВЛЕННЯ
          </Button>
        </div>
      </aside>
    </div>
  );
}
